/*
 * Undo nach dem Entfernen einer Warenkorbposition (Papierkorb im Stepper oder Loeschen-Link).
 * Seit 3.7 KEIN schwebender Toast mehr (der lag rechts unten halb unter dem Drawer bzw.
 * ueber dem Footer), sondern eine Inline-Zeile "Artikel entfernt | Rueckgaengig" an der
 * Stelle der Positionsliste, oben in <line-items>. Sie wird nach dem AJAX-Re-Render der
 * Liste eingesetzt (Aufruf aus line-items.js renderSections) und erscheint damit exakt dort,
 * wo der Artikel gerade verschwunden ist: im Drawer und auf der Warenkorb-Seite gleich.
 * Es gibt immer nur EINE Undo-Zeile (fuer den zuletzt entfernten Artikel), sie verschwindet
 * nach 6 Sekunden von selbst. Klick fuegt die Variante mit der vorherigen Menge wieder hinzu
 * und triggert 'cart:refresh' (Re-Render in line-items.js). Texte kommen lokalisiert aus
 * line-item.liquid (data-removed-text / data-undo-text). Styles: snippets/line-items.liquid.
 */
(function () {
  if (window.tsiRemoveUndo) return;

  var UNDO_TIMEOUT = 6000;

  function clearPending() {
    window.__tsiPendingUndo = null;
    if (window.__tsiUndoTimer) {
      clearTimeout(window.__tsiUndoTimer);
      window.__tsiUndoTimer = null;
    }
    document.querySelectorAll('.tsi-undo-row').forEach(function (el) {
      el.remove();
    });
  }

  window.tsiClearUndo = clearPending;

  // Merkt sich die entfernte Position. Die Zeile selbst wird erst nach dem Re-Render
  // der Liste gezeichnet (tsiRenderUndoRow), sonst wuerde innerHTML sie sofort ueberschreiben.
  window.tsiRemoveUndo = function (lineItemEl) {
    if (!lineItemEl) return;
    var variantId = lineItemEl.dataset.variantId;
    var quantity = parseInt(lineItemEl.dataset.quantity, 10);
    if (!variantId || isNaN(quantity) || quantity < 1) return;

    clearPending();

    window.__tsiPendingUndo = {
      variantId: variantId,
      quantity: quantity,
      removedText: lineItemEl.dataset.removedText || 'Artikel entfernt',
      undoText: lineItemEl.dataset.undoText || 'Rückgängig',
      createdAt: Date.now(),
    };

    // Sicherheitsnetz: falls der Re-Render ausbleibt (z.B. Fehler beim Entfernen),
    // verfaellt das Undo trotzdem nach UNDO_TIMEOUT.
    window.__tsiUndoTimer = setTimeout(clearPending, UNDO_TIMEOUT);
  };

  // Zeichnet die Undo-Zeile ganz oben in das uebergebene <line-items>-Element.
  window.tsiRenderUndoRow = function (lineItemsEl) {
    var pending = window.__tsiPendingUndo;
    if (!pending || !lineItemsEl) return;

    var age = Date.now() - pending.createdAt;
    if (age > UNDO_TIMEOUT) {
      clearPending();
      return;
    }

    lineItemsEl.querySelectorAll('.tsi-undo-row').forEach(function (el) {
      el.remove();
    });

    var row = document.createElement('div');
    row.className = 'tsi-undo-row';
    row.setAttribute('role', 'status');
    row.innerHTML =
      '<span class="tsi-undo-row__text">' +
      pending.removedText +
      '</span>' +
      '<button type="button" class="tsi-undo-row__button" data-tsi-undo data-variant-id="' +
      pending.variantId +
      '" data-quantity="' +
      pending.quantity +
      '">' +
      pending.undoText +
      '</button>';

    lineItemsEl.insertBefore(row, lineItemsEl.firstChild);

    if (window.__tsiUndoTimer) clearTimeout(window.__tsiUndoTimer);
    window.__tsiUndoTimer = setTimeout(clearPending, UNDO_TIMEOUT - age);
  };

  document.addEventListener('click', async function (event) {
    var btn = event.target.closest('[data-tsi-undo]');
    if (!btn || btn.disabled) return;
    btn.disabled = true;

    var variantId = parseInt(btn.dataset.variantId, 10);
    var quantity = parseInt(btn.dataset.quantity, 10);

    clearPending();

    try {
      var response = await fetch(routes.cart_add_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [
            {
              id: variantId,
              quantity: quantity,
            },
          ],
        }),
      });
      var data = await response.json();
      if (!response.ok) throw new Error(data.message || data.description || 'Error');

      publish('cart:refresh');
    } catch (error) {
      console.error(error);
      if (window.toast) window.toast.error(error.message);
    }
  });
})();

class CartItem extends HTMLElement {
  connectedCallback() {
    this.cartItemLine = this.dataset.lineItemIndex;
    this.loadingOverlay = this.querySelector('.loading-overlay');

    this.unsubscribeCartUpdating = subscribe('cart:updating', ({ line }) =>
      this.toggleLoading(line, true)
    );
    this.unsubscribeCartError = subscribe('cart:error', ({ line }) =>
      this.toggleLoading(line, false)
    );

    this.addEventListener('click', (event) => {
      // Klickbarer Staffel-Nudge: setzt die Menge der Position direkt auf die
      // naechste Staffelstufe (data-quantity aus line-item.liquid).
      const nudge = event.target.closest('[data-tsi-tier-nudge]');
      if (nudge) {
        const quantity = parseInt(nudge.dataset.quantity, 10);
        if (!isNaN(quantity) && quantity > 0) {
          publish('cart:change', {
            line: this.cartItemLine,
            quantity,
          });
        }
        return;
      }

      if (!event.target.closest('[data-line-item-remove]')) return;
      event.preventDefault();
      if (window.tsiRemoveUndo) window.tsiRemoveUndo(this);
      publish('cart:change', {
        line: this.cartItemLine,
        quantity: 0,
      });
    });
  }

  disconnectedCallback() {
    this.unsubscribeCartUpdating();
    this.unsubscribeCartError();
  }

  /**
   * Toggle the loading overlay.
   * @param {boolean} isLoading - Whether to show or hide the loading overlay.
   */
  toggleLoading(line, isLoading) {
    if (line !== this.cartItemLine) return;
    this.loadingOverlay.ariaHidden = !isLoading;
  }
}

customElements.define('line-item', CartItem);
